import React from "react";
import styles from "./webstory.module.scss";

const WebStory = ({ item }) => {
  return (
    <div className={styles.storyWrapper}>
      <a className={styles.imgWrapper} href={item?.url || "#"}>
        <img
          src={item?.posters?.portrait || ""}
          alt={item?.title || "web-story-img"}
          height={375}
          width={250}
          className={styles.storyImg}
        />
      </a>
      <div className={styles.titleContainer}>
        <div className={styles?.title}>{item?.title || ""}</div>
      </div>
    </div>
  );
};

export default WebStory;
